/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    EditTeamData: null,
    EditTeamDataCode : null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.EditTeamdataAction.REQUEST_EDITTEAMDATA:
      return {
        ...state
      };
    case actions.EditTeamdataAction.EDITTEAMDATA_RECEIVED:
      return {
        ...state,
        EditTeamData: action.data,
        EditTeamDataCode : action.data
      };

      case actions.EditClientAdminAction.CLEAR_EDITTEAMDATA:
        return {
          ...state,
          EditTeamDataCode : null
        };  

    default:
      return state;
  }
};

export default reducer;
